import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
                delayChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <footer className="footer-modern">
            <div className="footer-content-wrapper">
                <motion.div
                    className="container"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={containerVariants}
                >
                    <div className="row g-5 py-5 justify-content-between">
                        {/* Sección de Servicios */}
                        <motion.div className="col-lg-5" variants={itemVariants}>
                            <div className="footer-glass-card">
                                <h3 className="footer-title">
                                    Nuestros Servicios
                                </h3>
                                <div className="footer-links">
                                    <Link to='/ingenieria' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Ingeniería y proyectos
                                    </Link>
                                    <Link to='/tableros' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Armado de tableros eléctricos
                                    </Link>
                                    <Link to='/termografia' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Termografía y mediciones
                                    </Link>
                                    <Link to='/mantenimiento' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Mantenimiento
                                    </Link>
                                    <Link to='/instalaciones' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Instalaciones
                                    </Link>
                                    <Link to='/capacitacion' className="footer-link">
                                        <i className="bi bi-chevron-right"></i>
                                        Capacitación
                                    </Link>
                                </div>
                            </div>
                        </motion.div>

                        {/* Sección de Contacto */}
                        <motion.div className="col-lg-5" variants={itemVariants}>
                            <div className="footer-glass-card">
                                <h3 className="footer-title">
                                    Contacto
                                </h3>
                                <p className="footer-description">
                                    Estamos aquí para ayudarte. Contáctanos por cualquiera de estos medios.
                                </p>
                                <div className="footer-contact-info">
                                    <a className='footer-contact-link' href='https://maps.app.goo.gl/qtHc1mjJZHagBLH39' target="_blank" rel="noreferrer">
                                        <i className="bi bi-geo-alt-fill footer-contact-icon"></i>
                                        <span>Alonso de Reinoso 3449, Córdoba Capital, Argentina</span>
                                    </a>
                                    <a className='footer-contact-link' href='mailto:info@idelek.com.ar'>
                                        <i className="bi bi-envelope-at-fill footer-contact-icon"></i>
                                        <span>info@idelek.com.ar</span>
                                    </a>
                                    <a className='footer-contact-link' href='tel:+5493515165848'>
                                        <i className="bi bi-telephone-fill footer-contact-icon"></i>
                                        <span>351 516-5848</span>
                                    </a>
                                </div>
                            </div>
                        </motion.div>
                    </div>

                    {/* Separador con gradiente */}
                    <div className="gradient-separator"></div>

                    {/* Redes Sociales */}
                    <motion.div
                        className="footer-social-section"
                        variants={itemVariants}
                    >
                        <h4 className="footer-social-title">Síguenos</h4>
                        <div className="footer-social-links">
                            <motion.a
                                href="https://api.whatsapp.com/send?phone=5493515165848"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-social-btn whatsapp"
                            >
                                <i className="bi bi-whatsapp"></i>
                            </motion.a>
                            <motion.a
                                href="https://www.linkedin.com/company/idelek-s-a-s/"
                                target="_blank"
                                rel="noreferrer"
                                className="footer-social-btn linkedin"
                            >
                                <i className="bi bi-linkedin"></i>
                            </motion.a>
                        </div>
                    </motion.div>
                </motion.div>
            </div>

            {/* Copyright Section */}
            <div className="footer-bottom">
                <div className="container">
                    <div className="footer-bottom-content">
                        <p className="footer-copyright">
                            © 2026 Copyright - Todos los derechos reservados de <strong>IDELEK S.A.S.</strong>
                        </p>
                        <div className="footer-afip">
                            <a href="http://qr.afip.gob.ar/?qr=n0x3DUDFrPJY8FH550P6ag,," target="_F960AFIPInfo">
                                <img src="https://www.afip.gob.ar/images/f960/DATAWEB.jpg" alt="Data Fiscal Idelek" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
